module.exports = __webpack_public_path__ + "img/YBC-alt.761ad068.svg";